import type { ProfileConfig } from "@worker/config-schema";
import { el } from "../lib/dom";

/**
 * Inline clock for the meta row (or anywhere else a template drops it). Not
 * a widget — it's a tiny pill-sized component intended to sit beside the
 * view counter and location.
 */
export function mountInlineClock(
  cfg: ProfileConfig["profile"]["inlineClock"],
): HTMLElement | null {
  if (!cfg.enabled) return null;

  const node = el("span", { class: "inline-clock", "aria-live": "polite" });
  const timeEl = el("span", { class: "inline-clock__time" });
  node.append(timeEl);

  let fmt: Intl.DateTimeFormat;
  try {
    fmt = new Intl.DateTimeFormat(undefined, {
      timeZone: cfg.timezone,
      hour: "2-digit",
      minute: "2-digit",
      ...(cfg.showSeconds ? { second: "2-digit" as const } : {}),
      hour12: cfg.format === "12",
    });
  } catch {
    timeEl.textContent = "??:??";
    return node;
  }

  const tick = () => {
    timeEl.textContent = fmt.format(new Date());
  };
  tick();
  const interval = window.setInterval(tick, cfg.showSeconds ? 1000 : 15_000);
  node.addEventListener("bio:teardown", () => window.clearInterval(interval));
  return node;
}
